export default class Share {

	/**
	 * @param {string} social
	 * @param {string} url
	 * @returns {string|null}
	 */

	static getUrl(social, url) {
		if (Share.urlList[social]) {
			return Share.urlList[social] + encodeURIComponent(url);
		}

		return null;
	}

	/**
	 * @param {string} url
	 * @param {Promise|null} [promise]
	 * @param {string} [title]
	 * @param {string} [features]
	 * @returns {Window}
	 */

	static openWindow(url, promise = null, title = 'Поделиться', features = 'width=640,height=480,location=no,toolbar=no,menubar=no') {
		let shareWindow;

		if (promise) {
			shareWindow = window.open('', title, features);

			promise
				.then(() => {
					shareWindow.location = url;
				})
				.catch(() => {
					shareWindow.close();
				});
		} else {
			shareWindow = window.open(url, title, features);
		}

		return shareWindow;
	}

	/**
	 * @param {string} url
	 * @param {Promise|null} [promise]
	 * @returns {Window}
	 */

	static facebook(url, promise = null) {
		return Share.openWindow(Share.getUrl('facebook', url), promise);
	}

	static vk(url, promise = null) {
		return Share.openWindow(Share.getUrl('vk', url), promise);
	}

	static twitter(url, promise = null) {
		return Share.openWindow(Share.getUrl('twitter', url), promise);
	}

	static ok(url, promise = null) {
		return Share.openWindow(Share.getUrl('ok', url), promise);
	}

	static telegram(url, promise = null) {
		return Share.openWindow(Share.getUrl('telegram', url), promise);
	}

	static mailru(url, promise = null) {
		return Share.openWindow(Share.getUrl('mailru', url), promise);
	}

    static flip(url, promise = null) {
		return Share.openWindow(Share.getUrl('flip', url), promise);
	}
}

Share.urlList = {
    facebook: 'https://facebook.com/sharer/sharer.php?u=',
    vk: 'https://vk.com/share.php?url=',
    twitter: 'https://twitter.com/share?url=',
    mailru: 'https://connect.mail.ru/share?url=https://www.kp.ru/best/msk/podpiska/weekly/&title=%D0%9F%D0%BE%D0%B4%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%9A%D0%9F&description=%D0%9E%D0%B4%D0%B8%D0%BD%20%D1%80%D0%B0%D0%B7%20%D0%B2%20%D0%BD%D0%B5%D0%B4%D0%B5%D0%BB%D1%8E%20%D0%B4%D0%B0%D0%B9%D0%B4%D0%B6%D0%B5%D1%81%D1%82%20%D0%BB%D1%83%D1%87%D1%88%D0%B8%D1%85%20%D1%81%D1%82%D0%B0%D1%82%D0%B5%D0%B9%20%D0%B8%20%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%B2%D1%8C%D1%8E&imageurl=',
    flip: 'https://share.flipboard.com/bookmarklet/popout?v=2&title=%D0%9F%D0%BE%D0%B4%D0%BF%D0%B8%D1%88%D0%B8%D1%81%D1%8C%20%D0%BD%D0%B0%20%D0%9A%D0%BE%D0%BC%D1%81%D0%BE%D0%BC%D0%BE%D0%BB%D1%8C%D1%81%D0%BA%D1%83%D1%8E%20%D0%9F%D1%80%D0%B0%D0%B2%D0%B4%D1%83&url=https%3A%2F%2Fwww.kp.ru%2Fbest%2Fmsk%2Fpodpiska%2F&t=1616599315413&utm_campaign=tools&utm_medium=article-share&utm_source=www.kp.ru',
	ok: 'https://connect.ok.ru/offer?url='
};